import { useEffect, useState } from 'react';
const useProgressiveLoadingText = breakpoints => {
  const [loadingText, setLoadingText] = useState(breakpoints[0].text);
  useEffect(() => {
    const timeouts = breakpoints.map(({
      text,
      ms
    }) => setTimeout(() => {
      setLoadingText(text);
    }, ms));
    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [setLoadingText, breakpoints]);
  return loadingText;
};
export default useProgressiveLoadingText;